// 埋点
import load from './load'

let hasLoadDependencies = false

const getDependencies = () => {
  return new Promise((resolve, reject) => {
    require.ensure([], (require) => {
      // fix zepto在编译时this的指向问题，见https://segmentfault.com/q/1010000006887270
      window['$'] = require('webpack-zepto')

      // load.getScript('//3rd.vipstatic.com/mars_vipapp/mars_vipapp.js', resolve, reject)
      load.getScript('//3rd.vipstatic.com/mars_wap/mars_wap.js', resolve, reject)
    })
  })
}

const send = (seed, value = '-', element = 'span', type = 'click') => {
  // value只能是字符串
  let marsData = value
  if ((typeof value).toLowerCase() === 'object') {
    marsData = JSON.stringify(value)
  }

  Mar.Seed.request(element, type, seed, marsData)
}

const mars = {
  send (seed, value, cb) {
    if (hasLoadDependencies) {
      send(seed, value)
      cb && cb()
    }
    else {
      getDependencies().then(() => {
        hasLoadDependencies = true
        send(seed, value)
        cb && cb()
      })
    }
  }
}

// http://gitlab.tools.vipshop.com/mars/mars_cid/blob/master/index.js
const Cid = {
  /**
   * 创建mars_cid
   * @method create
   * @returns {String} 安全加密的 mars_cid
   */
  creat () {
    return Cid.encrypt(`${Cid._pad((new Date()).getTime(), 13)}_${Cid._rand()}`)
  },
  /**
   * 安全加密mars_cid
   * @method encrypt
   * @param timestampMarId {String} 时间戳+随机数 46位
   * @returns {String} 安全加密的 mars_cid
   */
  encrypt (timestampMarId) {
    // split mar Id
    const marArr = timestampMarId.split('_')
    const timestamp = marArr[0]
    const marId = marArr[1]
    if (!timestamp || !marId) {
      return timestampMarId
    }

    // the sum of numbers from timestamp
    let timestampSum = 0
    const timestampLen = timestamp.length
    for (let i = 0; i < timestampLen; i++) {
      timestampSum += parseInt(timestamp[i])
    }

    const replaceIndex = timestampSum % 32

    // the sum of all whole numbers from timestampMarId
    let dechexSum = timestampSum
    const marIdLen = marId.length
    for (let i = 0; i < marIdLen; i++) {
      if (i !== replaceIndex) {
        dechexSum += parseInt(marId[i], 16)
      }
    }

    const replaceValue = (dechexSum % 16).toString(16)

    return `${timestamp}_${marId.substr(0, replaceIndex)}${replaceValue.toString()}${marId.substr(replaceIndex + 1, marIdLen)}`
  },
  /**
   * 解密校验
   * @method validate
   * @param encryptStr {String} 时间戳_随机数 46位
   * @returns {Boolean} 是否是安全加密的 mars_cid
   */
  validate (encryptStr) {
    if (!encryptStr) {
      return false
    }
    const marArr = encryptStr.split('_')

    const timestamp = marArr[0]
    const marId = marArr[1]
    if (!timestamp || !marId) {
      return false
    }
    // the sum of numbers from timestamp
    let timestampSum = 0
    const timestampLen = timestamp.length
    for (let i = 0; i < timestampLen; i++) {
      timestampSum += parseInt(timestamp[i])
    }
    const replaceIndex = timestampSum % 32

    const originMarId = marId.substr(0, replaceIndex) + marId.substr(replaceIndex + 1),
      replaceValue = marId[replaceIndex]

    // the sum of all whole numbers from timestampMarId
    let dechexSum = timestampSum
    const marIdLen = originMarId.length
    for (let i = 0; i < marIdLen; i++) {
      dechexSum += parseInt(originMarId[i], 16)
    }

    return parseInt(replaceValue, 16) === dechexSum % 16
  },
  /**
   * 补0
   * @method pad
   * @param num {Number | String} 原数字
   * @param n {Number} 位数
   * @returns {string} 补0后的数字
   */
  _pad (num, n) {
    let len = num.toString().length
    while (len < n) {
      num = `0${num}`
      len++
    }
    return num
  },
  /**
   * 生成指定长度的随机数 <br>
   * 目前用于生成mars_sid 和 mars_cid的随机数部分
   * @method rand
   * @param [len] {number} 长度 默认是32位
   * @returns {string} 随机数 例如：bb534acdd50ba1519bb4dcf534112ddc
   */
  _rand (len) {
    const hexStr = '0123456789abcdef'
    let tmp = ''
    len = len || 32
    for (let i = 0; i < len; i++) {
      tmp += hexStr.charAt(Math.ceil(Math.random() * 100000000) % hexStr.length)
    }
    return tmp
  }
}

export default mars
export {
  getDependencies,
  Cid,
  mars
}



// WEBPACK FOOTER //
// ./src/lib/mars/index.js